import _ from 'lodash'
import api from '../../api'
import socket from '../../plugins/socketIO'
import router from '../../router'

const defaultState = () => ({
  teams: [],
  players: [],
})

export default {
  defaultState,
  state: defaultState,
  getters: {
    lobbyTeams: state => state.teams.map(team => ({
      ...team,
      players: state.players.filter((player, index, self) => {
        if (player.teamId === team.id) {
          return self.findIndex(p => p.username === player.username) === index;
        }
        return false;
      })
    })),
    lobbyMe: (state, getters) => state.players.find(player => player.id === getters.me.id) || {},
    lobbyMyTeamId: (state, getters) => getters.lobbyMe.teamId,
    lobbyPlayersWithoutTeam: state => state.players.filter(player => !player.isOwner && !player.teamId),
  },
  actions: {
    async join({commit, dispatch, getters}, {code = null, id = null} = {}) {
      dispatch('toggleLoader', true)
      let result = {}
      await socket.waitForConnection()

      try {
        if (code) {
          result = await api.gameLobby.findByCodeAndJoin(code)
        } else if (id) {
          result = await api.gameLobby.findByIdAndJoin(id)
        }
        commit('SET_MY_GAME', result.data.game)
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error(`Game connection failed.`)
      }

      dispatch('toggleLoader', false)
      return false
    },
    async joinArchivedGame({commit, dispatch, getters}, game) {
      dispatch('toggleLoader', true)
      try {
        let result = {}
        console.log(game);
        /*result = await api.game.findOne(game.game.id)*/
        result = await api.userAccount.meForArchived(game.game.id)
        /*await api.gameLobby.addCurrentUserToTeam(game.team.id)*/
        console.log(getters.archivedGames)
        commit('SET_MY_GAME', result.data.game)
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error(`Game connection failed.`)
      }

      dispatch('toggleLoader', false)
      return false

    },
    async fetchLobby({commit, getters, dispatch}) {
      dispatch('toggleLoader', true)
      if (getters.amIOwner || getters.amIAdmin) {
        await dispatch('fetchMe')
        await dispatch('fetchOwnActiveGames')
      }
      const game = getters.joinedGame
      var dataVar = [];

      try {
        await socket.waitForConnection()
        await socket.unsubscribe()
        const {data} = await api.gameLobby.findLobbyDataById(game.id)

        commit('SET_TEAMS', data.teams)
        commit('SET_PLAYERS', [...data.players, {...data.owner, isOwner: true}])
        if (!game.endedTime) {
          socket.subscribeGame(game.id)
        }

        dataVar = data;
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
      dispatch('toggleLoader', false)
      return dataVar;

    },
    async createTeam({commit, getters, dispatch}, name) {
      dispatch('toggleLoader', true)
      const game = getters.joinedGame
      try {
        const {data} = await api.team.save({gameId: game.id, name})
        commit('SET_PLAYER_TEAM', {id: getters.me.id, teamId: data.id})
        return true;
      } catch (e) {
        dispatch('toggleLoader', false)
        this.showError(e)
      }

      return false;
    },
    async joinTeam({dispatch}, id) {
      dispatch('toggleLoader', true)
      try {
        await api.gameLobby.addCurrentUserToTeam(id)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }

      return false
    },
    async leaveTeam({dispatch}) {
      dispatch('removeUserFromTeam')
    },
    async removeUserFromTeam({dispatch}, id = null) {
      dispatch('toggleLoader', true)
      try {
        await api.gameLobby.removeUserFromTeam(id)
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }

      dispatch('toggleLoader', false)
      return false
    },
    async removeUserFromLobby({dispatch}, id) {
      dispatch('toggleLoader', true)
      try {
        await api.gameLobby.removeUserFromLobby(id)
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }

      dispatch('toggleLoader', false)
      return false
    },
    SOCKET_GAME_USER_JOIN({commit}, user) {
      commit('ADD_PLAYER', user)
    },
    SOCKET_GAME_TEAM_CREATE({commit, dispatch}, team) {
      dispatch('toggleLoader', false)
      commit('SET_PLAYER_TEAM', team.users[0])
      delete team.users
      commit('ADD_TEAM', team)
    },
    SOCKET_GAME_TEAM_JOIN({commit, dispatch}, payload) {
      dispatch('toggleLoader', false)
      commit('SET_PLAYER_TEAM', payload)
    },
    SOCKET_GAME_TEAM_LEFT({commit, dispatch}, {id}) {
      dispatch('toggleLoader', false)
      commit('SET_PLAYER_TEAM', {id, teamId: null})
    },
    SOCKET_GAME_USER_LEFT({commit}, playerId) {
      commit('REMOVE_PLAYER', playerId)
    },
    SOCKET_GAME_TEAM_DELETE({commit, state}, id) {
      this.$toast.info(`Team "${state.teams.find(team => team.id === id).name}" was deleted by admin.`)
      commit('REMOVE_TEAM', id)
    },
    async SOCKET_GAME_START({getters, dispatch}) {
      if (!getters.imIOwner) {
        await router.push({name: 'Game.GameOverview'})
      }
    }
  },
  mutations: {
    SET_GAME(state, game) {
      state.game = game
    },
    SET_TEAMS(state, teams) {
      state.teams = teams || []
    },
    SET_PLAYERS(state, players) {
      state.players = players || []
    },
    SET_PLAYER_TEAM(state, {id, teamId}) {
      state.players = state.players.map(player => {
        if (player.id === id) {
          player.teamId = teamId
        }
        return player
      })
    },
    ADD_PLAYER(state, player) {
      state.players.push(player);
    },
    ADD_TEAM(state, team) {
      state.teams.push(team);
    },
    REMOVE_TEAM(state, teamId) {
      state.teams = state.teams.filter(t => t.id !== teamId);
      state.players = state.players.map(player => {
        if (player.teamId === teamId) {
          player.teamId = null
        }
        return player
      })
    },
    REMOVE_PLAYER(state, playerId) {
      state.players = state.players.filter(player => player.id !== playerId);
    }
  },
}
